<template>
    <div class="page-cabinet-transactions-list-card-container">
        <div class="page-cabinet-transactions-list-card-title">
            {{ formattedDay }}
        </div>

        <div class="page-cabinet-transactions-list-card-items">
            <ui-card-base
                v-bind:padding-top="'12px'"
                v-bind:padding-bottom="'12px'"
                v-for="item in items"
                v-bind:key="item.date"
                with-border
            >
                <article class="page-cabinet-transactions-list-card">
                    <span
                        class="page-cabinet-transactions-list-card__type"
                        v-text="item.type"
                    />
                    <span
                        class="page-cabinet-transactions-list-card__sum"
                        v-bind:class="{'_positive': item.amount > 0}"
                        v-text="item.sum"
                    />
                </article>
            </ui-card-base>
        </div>
    </div>
</template>

<script>
export default {
    name: 'page-cabinet-transactions-list-card',
    props: {
        day: {
            type: Object,
            default: () => {},
        },
        items: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    computed: {
        formattedDay() {
            const day = this.day;
            if (this.day.year) {
                return `${day.date} ${day.month} ${day.year}, ${day.dayOfWeek}`;
            }
            return `${day.date} ${day.month}, ${day.dayOfWeek}`;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-transactions-list-card-container {
    display: flex;
    flex-direction: column;
    gap: 8px
}

.page-cabinet-transactions-list-card-title {
    .typography-subhead-2();
    font-size: 13px;

    text-transform: uppercase;
    color: @color-gray-main;
}

.page-cabinet-transactions-list-card-items {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.page-cabinet-transactions-list-card {
    .typography-body();

    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    &__title {
        width: ~'calc(100% - 82px)';
    }
    &__date {
        width: 82px;
        padding-left: 12px;

        color: @color-gray-main;
        text-align: right;
    }
    &__type {
        // width: 100%;
        // margin-top: 22px;
        flex: 1;
        &-caption {
            color: @color-gray-main;
        }
    }
    &__sum {
        // width: 100%;
        flex-shrink: 0;
        &._positive {
            color: @color-positive;
        }
        &-caption {
            color: @color-gray-main;
        }
    }
}
</style>
